import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";

function TestDateTable() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios.get("/api/testdatetable")
      .then((res) => {
        setRows(res.data.data || res.data);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, []);

  const columns = [
  { field: 'id', headerName: 'Id', type: 'number', width: 80 },
  { field: 'card_name', headerName: 'Card Name', type: 'string', width: 130 },
  { field: 'created_at', headerName: 'Created At', width: 80, renderCell: (params) => {
    const raw = params.row?.created_at;
    if (!raw) return "";
    const date = new Date(raw);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-AU', { month: 'short' });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
} },
  { field: 'updated_at', headerName: 'Updated At', width: 80, renderCell: (params) => {
    const raw = params.row?.updated_at;
    if (!raw) return "";
    const date = new Date(raw);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-AU', { month: 'short' });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
} }
  ];

  return (
    <div style={{ height: '80vh', width: '100%' }}>
      <h2>TestDateTable</h2>
      <DataGrid rows={rows} columns={columns} getRowId={(row) => row.id} />
    </div>
  );
}

export default TestDateTable;
